import React from 'react';
import Icon from 'components/AppIcon';

const stats = [
  { label: 'Total Assets', value: '6', icon: 'Layers', iconColor: 'var(--color-primary)', iconBg: 'rgba(59,76,76,0.08)' },
  { label: 'Total AUM', value: '£1.24B', icon: 'TrendingUp', iconColor: 'var(--color-primary)', iconBg: 'rgba(59,76,76,0.12)' },
  { label: 'Avg. Net IRR', value: '11.8%', icon: 'BarChart3', iconColor: '#7C3AED', iconBg: 'rgba(124,58,237,0.08)' },
  { label: 'Avg. ESG Score', value: '74 / 100', icon: 'Leaf', iconColor: '#059669', iconBg: 'rgba(5,150,105,0.08)' },
  { label: 'Capital Deployed', value: '£892M', icon: 'PoundSterling', iconColor: 'var(--color-success)', iconBg: 'rgba(5,150,105,0.08)' },
];

export default function SummaryStatsBar() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {stats?.map((s) => (
        <div
          key={s?.label}
          className="card flex items-center gap-3"
          style={{ padding: '16px 20px' }}
        >
          <div
            className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg"
            style={{ background: s?.iconBg }}
          >
            <Icon name={s?.icon} size={20} color={s?.iconColor} strokeWidth={1.8} />
          </div>
          <div className="min-w-0">
            <p className="font-caption text-muted-foreground truncate" style={{ fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{s?.label}</p>
            <p className="font-heading font-semibold text-foreground" style={{ fontSize: '1.125rem', lineHeight: 1.2 }}>{s?.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
